import api from './api'

const API = '/api/scanned-voter-uploads'

export const ScannedVoterUpload = {
  get: function(params) {
    return api.get(API, {params: params})
  },
  show: function(id, params) {
    return api.get(API + '/' + id, params)
  },
  create: function(form) {
    return api.createFormData(API, form)
  },
  update: function(id,form) {
    return api.update(API+'/'+id, form)
  },
  delete: function(id) {
    return api.delete(API+'/'+id)
  },
}
